module.exports = __webpack_public_path__ + "img/region.0658d3e4.png";